import cookie from 'js-cookie';

const CheckLogin = () => {
    return cookie?.get('authToken') || null;
}

export default CheckLogin;
